<template>
  <div class="product-page margin-xl-top margin-xl-bottom">
    <div class="container container-xl margin-inline-auto margin-2xl-bottom">
      <div class="breadcrumbs flex gap-xs text-s c-gray-4 margin-m-bottom">
        <saffron-link :to="{ name: 'store' }">{{
          tu("ag.store.breadcrumbs.store")
        }}</saffron-link>
        <span>&nbsp;/&nbsp;</span>
        <span v-if="product">{{ tu(product.name) }}</span>
      </div>
      <div
        class="main-content flex gap-2xl flex-column flex-middle l:flex-row l:flex-between l:flex-stretch">
        <div class="content-side">
          <spinner v-if="!product" size="5"></spinner>
          <div v-if="product">
            <ag-title :auto-translate="false" class="margin-s-bottom">{{
              product.name
            }}</ag-title>
            <div class="review-summary text-s">
              <div class="flex gap-m flex-middle">
                <div class="flex gap-xs flex-middle">
                  <icon
                    v-for="i in 5"
                    icon="ag-star"
                    :theme="product.reviewScoreStars >= i ? 'alt' : 'gray'"></icon>
                </div>
                <span>
                  {{
                    tu("ag.store.reviews.reviewCount", { count: product?.Reviews.length })
                  }}
                </span>
              </div>
            </div>
            <div class="price margin-xl-vertical text-max c-gray-4">
              {{ translateNumber(product.price, "currency") }}
            </div>
            <!--
            <div
              class="controls border padding margin-xl-bottom"
              style="min-height: 200px">
              <div v-if="product.MultiVariantProductType" class="variants-selection">
                <div
                  v-for="variantSet of product.MultiVariantProductType.variantSets"
                  class="variant-selection margin-l-bottom">
                  <div class="label margin-s-bottom">
                    <span>{{ variantSet.label }}</span>
                    <span v-if="isAnyVariantSelected(variantSet)"
                      >&nbsp;&middot;&nbsp;</span
                    >
                    <span v-if="isAnyVariantSelected(variantSet)">{{
                      getSelectedVariantByVariantSet(variantSet).label
                    }}</span>
                  </div>

                  <div class="flex gap-l">
                    <div
                      v-for="variant of variantSet.variants"
                      v-if="variantSet.selectionUi === 'images'"
                      class="image-variant-select border-radius-s padding"
                      :class="{
                        'bg-lead': isVariantSelected(variantSet, variant),
                        'bg-gray-1': !isVariantSelected(variantSet, variant),
                      }"
                      @click="setVariantOption(variantSet, variant)">
                      <img
                        :src="variant.imageUrl"
                        style="aspect-ratio: 0.75; width: 60px" />
                    </div>
                    <badge
                      v-for="variant of variantSet.variants"
                      v-else
                      class="padding-l-inline cursor-pointer"
                      style="border: 1px solid var(--c-gray-1)"
                      :auto-translate="false"
                      size="l"
                      :theme="
                        orderOptions?.multiVariant &&
                        orderOptions?.multiVariant[variantSet.name] === variant.name
                          ? 'lead'
                          : 'bg'
                      "
                      @click="setVariantOption(variantSet, variant)">
                      <span>
                        {{ variant.label }}
                      </span>
                    </badge>
                  </div>
                </div>
              </div>

              <div class="quantity-controls-wrapper">
                <form-input
                  type="units"
                  class="test-form-control max-width-300"
                  :auto-input-styling="false"
                  size="s"
                  label="כמות"></form-input>
              </div>
            </div>
            <form-button
              class="width-expand"
              icon-end="arrow-inline-end"
              text="לקניה"></form-button>
-->
            <base-form
              @form:submit-success="addToCartByState"
              v-model="orderData"
                       :config="orderFormConfig"></base-form>
          </div>
        </div>
        <div
          v-if="product && product.images && product.images.length > 0"
          class="media-side width-expand"
          style="min-height: 200px">
          <div class="gallery">
            <div class="main-image flex-middle flex-center">
              <img :src="currentImageUrl" alt="" />
            </div>
            <div class="margin-l-top">
              <slider
                class=""
                :config="mediaSliderConfig"
                :navigation-theme-type="'minimal'">
                <slide
                  v-for="(image, index) of product.images"
                  style="height: 150px; width: 200px"
                  class="background-cover border-radius border-thin-gray-1"
                  :style="`background-image: url('${image.url}');`"
                  :class="{ active: index === currentImageIndex }"
                  @click="currentImageIndex = index">
                </slide>
              </slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useCarts from '@/client/extensions/composition/useCarts'
import asyncOperations from "@/client/extensions/composition/asyncOperations";

export default {
  layout: "default",
  middleware: {},
  props: {
    productId: {
      type: [String, Number],
      default: 0,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady } = asyncOperations(props);
    let carts = useCarts();
    return { asyncOps, asyncOpsReady,carts };
  },
  meta: "ag.meta.product.title",

  data: function () {
    return {
      product: false,
      currentImageIndex: 0,
      orderOptions: {
        quantity: 1,
      },
      orderData: {
        quantity: 1,
      },
      quantityFieldConfig: {
        name: "quantity",
        type: "units",
        class: "quantity-controls",
        label: "ag.store.product.quantity",
        validation: {
          required: {},
        }
      },
      mediaSliderConfig: {
        loop: false,
        slidesPerView: "auto",
        center: true,
        spaceBetween: 20,
        breakpoints: {
          767: {
            //  slidesPerView: 2,
          },
        },
        pagination: false,
        observer: true,
        observeParents: true,
        parallax: true,
        // Navigation arrows
        //   navigation: {
        //    nextEl: ".swiper-button-next",
        //    prevEl: ".swiper-button-prev",
        // },
      },
      orderFormConfig: {
        formHandling: {
          clientOnly: true,
        },
        fields: {},
        buttons: {
          submit: {
            class: "width-expand",
            iconEnd: "arrow-inline-end",
            type: "submit",
            text: "ag.store.product.purchaseCta",
          },
        },
      },
      asyncData: {
        product: {
          target: `ecommerce/product/${this.productId}`,
          data: {
            with: ["reviews"],
          },
          options: {
            dataMutator(data) {
              console.log(data.item);
              return data.item;
            },
            errorHandler: "404",
          },
        },
      },
    };
  },
  computed: {
    currentImageUrl() {
      return this.product.images[this.currentImageIndex].url;
    },
  },
  watch: {
    product(newVal) {
      let product = newVal;
      console.log("product");

      let newFields = {};
      this.orderData = {
        quantity: 1,
        multiVariant: {},
      };
      console.log("types", this.product.MultiVariantProductType);

      this.product.MultiVariantProductType.variantSets.forEach((set) => {
        this.orderData.multiVariant[set.name] = set?.variants[0]?.name;
        let field = {
          name: set.name,
          autoTranslate: false,
          label: set.label,
          type: "select2", //set.selectUi === "images" ? "imageRadio" : "badgeRadio",
          list: set.variants.map((variant) => {
            return {
              ...variant,
              value: variant.name,
              label: variant.label,
            };
          }),
          modelTarget: `multiVariant.${set.name}`,
          validation: {
            required: {},
          }
        };

        newFields[set.name] = field;
      });

      newFields.quantity = this.quantityFieldConfig;
      this.orderFormConfig.fields = newFields;
    },
  },
  methods: {
    async addToCartByState() {
      let cart = await this.carts.getCart();

      await cart.empty();
      let itemToAdd = {
        ProductId: this.product.id,
        quantity: this.orderData.quantity,
        productConfig: {
        },
      };

      if (this.orderData.multiVariant) {
        itemToAdd.productConfig.multiVariant = this.orderData.multiVariant
      }
      let addResult = await cart.addItem(itemToAdd);

      this.$router.push({ name: "store-checkout-standard", params: { locale: this.locale } });
    },
    getSelectedVariantByVariantSet(variantSet) {
      if (!this.isAnyVariantSelected(variantSet)) {
        return false;
      }
      // todo find the variant set
      return {
        name: "todo",
        label: "todo",
      };
    },
    isAnyVariantSelected(variantSet) {
      return (
        this.orderOptions?.multiVariant &&
        typeof this.orderOptions?.multiVariant[variantSet.name] !== "undefined"
      );
    },
    isVariantSelected(variantSet, variant) {
      return (
        this.orderOptions?.multiVariant &&
        this.orderOptions?.multiVariant[variantSet.name] === variant.name
      );
    },
    updateMetaByState() {
      if (!this.product) {
        return;
      }

      this.meta.title = this.t("ag.meta.product.titleSpecific", {
        productName: this.product.name,
      });
    },
    setVariantOption(variantSet, variant) {
      if (!this.orderOptions?.multiVariant) {
        this.orderOptions.multiVariant = {};
      }
      this.orderOptions.multiVariant[variantSet.name] = variant.name;
    },
  },
  serverPrefetch() {
    return this.getSSRPrefetchPromise();
  },
};
</script>

<style scoped lang="scss">
.main-content {
}

.media-side {
  width: 100%;
  @media (min-width: 1024px) {
    max-width: calc(100% - 500px - var(--margin-2xl));
  }

  @media (max-width: 1024px) {
    min-width: 100%;
    width: 100%;
    flex: 100%;
  }
}

.gallery {
  width: 100%;
  flex: 100%;
  @media (max-width: 1024px) {
    min-width: 100%;
  }
}

.main-image {
  width: 100%;
  border-radius: var(--border-radius);
  display: flex;

  @media (min-width: 1024px) {
    aspect-ratio: 2;
  }

  @media (max-width: 1024px) {
    height: 200px;
    padding: var(--margin-s);
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: top;
    border-radius: var(--border-radius);
  }
}

/*
.thumbs {
  .thumb {
    border: 1px solid var(--c-gray-1);
    border-radius: var(--border-radius);
    width: 240px;
    flex: 0 0 240px;
    height: 150px;

    //aspect-ratio: 0.66;

    img {
      object-fit: contain;
    }
  }
}

*/
.content-side {
  width: 500px;
  flex: 0 0 500px;
  min-height: 100px;

  @media (max-width: 767px) {
    width: 100%;
    max-width: 500px;
  }
}

:deep(.quantity-controls) {
  border-radius: 0;

  .field__controls-wrapper {
    border-radius: var(--border-radius-s);
  }

  input {
    border-radius: 0 !important;
  }
}
</style>
